import React from 'react';

export const SuccessCheck = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="46.5"
        height="46.5"
        rx="23.25"
        stroke="url(#paint0_linear_2740_53562)"
        strokeWidth="1.5"
      />
      <rect
        x="0.75"
        y="0.75"
        width="46.5"
        height="46.5"
        rx="23.25"
        stroke="url(#paint1_linear_2740_53562)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2011 16.2757C36.5996 16.6432 36.5996 17.2391 36.2011 17.6067L20.895 31.7243C20.4965 32.0919 19.8504 32.0919 19.4519 31.7243L11.7989 24.6655C11.4004 24.298 11.4004 23.702 11.7989 23.3345C12.1974 22.9669 12.8435 22.9669 13.2419 23.3345L20.1735 29.7278L34.7581 16.2757C35.1565 15.9081 35.8026 15.9081 36.2011 16.2757Z"
        fill="url(#paint2_linear_2740_53562)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2011 16.2757C36.5996 16.6432 36.5996 17.2391 36.2011 17.6067L20.895 31.7243C20.4965 32.0919 19.8504 32.0919 19.4519 31.7243L11.7989 24.6655C11.4004 24.298 11.4004 23.702 11.7989 23.3345C12.1974 22.9669 12.8435 22.9669 13.2419 23.3345L20.1735 29.7278L34.7581 16.2757C35.1565 15.9081 35.8026 15.9081 36.2011 16.2757Z"
        fill="url(#paint3_linear_2740_53562)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2740_53562"
          x1="33.0256"
          y1="-4.4186"
          x2="8.4359"
          y2="46.6977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#67A8EE" />
          <stop offset="1" stopColor="#91D7EB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2740_53562"
          x1="24"
          y1="-2.72093"
          x2="3.73691"
          y2="41.9823"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9C8F4" />
          <stop offset="1" stopColor="#B9C8F4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2740_53562"
          x1="28.7009"
          y1="14.5271"
          x2="15.8937"
          y2="31.5659"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#67A8EE" />
          <stop offset="1" stopColor="#91D7EB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2740_53562"
          x1="24"
          y1="15.093"
          x2="19.1935"
          y2="31.6614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9C8F4" />
          <stop offset="1" stopColor="#B9C8F4" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
